<!-- Profile Header Component -->
<ms-property-profile-header [(property)]="property" [isLoading]="isLoading()"
  [navItems]="filteredNavItems()" (tabChanged)="onTabChanged($event)" (editRequested)="onEditProperty()"
  (deactivateRequested)="confirmPropertyDeactivation()"
  (reactivateRequested)="confirmPropertyReactivation()"
  (deleteRequested)="confirmPropertyDeletion()"></ms-property-profile-header>

<!-- Tab Content Cards -->
<div class="tab-content mx-0 mx-sm-4 border-0" id="profileTabsContent">
  @if (property()) {
  @for (item of filteredNavItems(); track item.id; let i = $index) {
    @if (item.active) {
      <div class="tab-pane fade" [class.show]="item.active" [class.active]="item.active" [id]="item.id" role="tabpanel"
        [attr.aria-labelledby]="item.id + '-tab'" tabindex="0">

        <!-- Content slot for each tab -->
        @switch (item.id) {
        <!-- Overview Content -->
        @case ('property-data') {
          <ms-property-data [property]="property()" [isLoading]="isLoading()"></ms-property-data>
        }

        @case ('contacts') {
          <ms-property-contacts [property]="property()" (membersChanged)="onEditSuccess()"></ms-property-contacts>
        }

        @case ('invoicing') {
          <ms-property-invoicing [property]="property()"></ms-property-invoicing>
        }

        @case ('payment-history') {
          <div class="card mb-4">
            <div class="card-body">
              <ms-payment-history-list [property]="property()" [isEntityOwner]="isEntityOwner()"
                [viewLocation]="PaymentHistoryListViewLocations.PropertyProfilePage"></ms-payment-history-list>
            </div>
          </div>
        }

        @case ('logs') {
          <ms-property-logs [property]="property()"></ms-property-logs>
        }

        <!-- Default Content for other tabs -->
        @default {
        <div class="card">
          <div class="card-body">
            <p>Content for {{item.label}} will be implemented here.</p>
          </div>
        </div>
        }
        }
      </div>
    }
  }
  }
</div>

<!-- No [organization]: the modal only reads it on its Create path (title text and the createProperty
     payload) and this page always opens it to edit. Passing the active organization here named an
     organization unrelated to the property whenever the two diverged (DEV-2643). -->
<ms-property-form-modal
    [property]="property()" [formState]="editFormState()"
    (onSuccessConfirm)="onEditSuccess()"></ms-property-form-modal>

<ms-confirmation-modal #propertyProfileConfirmationModalRef modalId="propertyProfileConfirmationModal"
    [enableNotes]="false" [isNoteRequired]="false" confirmButtonText="Yes" cancelButtonText="No"
    [(isSubmitting)]="isSubmitting"
    (confirmed)="confirmationConfirmFunction($event)"
    (cancelled)="confirmationCancelFunction()" />

<ms-info-modal #propertyProfileInfoModalRef modalId="propertyProfileInfoModal" />
